import React from "react";
import Gallery from "../components/Gallery";
import LocationCard from "../components/LocationCard";
import CtaBand from "../components/CtaBand";
import useSeo from "../hooks/useSeo";
import useReveal from "../hooks/useReveal";
import { showroomPage, seo } from "../data/siteData";

export default function Showroom() {
  useSeo(seo["/showroom"].title, seo["/showroom"].description);
  useReveal();
  return (
    <>
      <section className="border-b-4 border-[#244aa2] bg-[#f7f7f7] py-12">
        <div className="mr-container">
          <h1 className="mr-h1 text-3xl sm:text-4xl">{showroomPage.h1}</h1>
          <h2 className="font-head mt-3 text-[15px] font-bold uppercase tracking-wide text-[#a10000]">
            {showroomPage.subhead}
          </h2>
        </div>
      </section>

      <section className="bg-white py-16">
        <div className="mr-container-wide grid gap-10 lg:grid-cols-3">
          <div className="mr-body reveal lg:col-span-2">
            {showroomPage.paragraphs.map((p) => (
              <p key={p.slice(0, 30)} className="text-[16.5px]">
                {p}
              </p>
            ))}
            <h2 className="mr-h2 mt-10 text-2xl">{showroomPage.secondSubhead}</h2>
            <p className="mt-3 text-[16.5px]">{showroomPage.secondParagraph}</p>
          </div>
          <div className="reveal">
            <LocationCard />
          </div>
        </div>
      </section>

      <Gallery images={showroomPage.showroomGallery} title="Inside The Showroom" columns={3} />
      <Gallery
        images={showroomPage.beforeAfter}
        title={showroomPage.beforeAfterTitle}
        columns={5}
      />
      <CtaBand headline="Book a showroom visit" copy="The Wolcott showroom is open by appointment — call (203) 578-5260 to arrange your visit." />
    </>
  );
}
